module.exports = __webpack_public_path__ + "img/createAccount.10611eab.webp";